import { Text } from '~/components/ui/Text';
import { StyledContainer } from './SectionHeading.styled';

interface ISectionHeadingProps {
	text: string;
	icon: string;
}

const SectionHeading: React.FC<ISectionHeadingProps> = ({
	text,
	icon,
}: ISectionHeadingProps) => {
	return (
		<StyledContainer>
			<img src={icon} />
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { SectionHeading };
